import firebaseUtil, { Firebase } from '../utils/firebase';

const useFirebase = (): Firebase => {
  return firebaseUtil.firebase;
};

export default useFirebase;
